import { render, staticRenderFns } from "./NsCurrency.vue?vue&type=template&id=0e878274&scoped=true&"
import script from "./NsCurrency.vue?vue&type=script&lang=js&"
export * from "./NsCurrency.vue?vue&type=script&lang=js&"
import style0 from "./NsCurrency.vue?vue&type=style&index=0&id=0e878274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e878274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e878274')) {
      api.createRecord('0e878274', component.options)
    } else {
      api.reload('0e878274', component.options)
    }
    module.hot.accept("./NsCurrency.vue?vue&type=template&id=0e878274&scoped=true&", function () {
      api.rerender('0e878274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsCurrency.vue"
export default component.exports